import { useThorEvent } from "@aviv-dxp/react-thor";
import { useTrackingEventsDatasNoItems } from "./useTracking";
export const useTrackingLeadFormError = () => {
    const EVENT_DATA = {
        ...useTrackingEventsDatasNoItems(true),
        event: "form_error",
        av_feature: "lead_classified_form",
    };
    return useThorEvent({
        compatibilities: { GA3: false, GA4: true },
        eventData: EVENT_DATA,
    });
};
